export default __webpack_public_path__ + "static/PhilReberger-feed5d238fe06478dc8afd5d27be2df0.jpg";